<template>
  <div id="app">
    <Loader />
    <ThemeToggle />
    <router-view />
  </div>
</template>

<script>
import Loader from "@/components/layout/Loader.vue";
import ThemeToggle from "@/components/layout/ThemeToggle.vue";
import { initTheme, toggleTheme as toggleThemeHelper } from "@/utils/theme";
import { NotificationService } from "@/Services/NotificationService";

export default {
  components: { Loader, ThemeToggle },
  computed: {
    loading() {
      return this.$store.getters.getLoadingState;
    },
  },
  data() {
    return {
      name: this.$route.name,
      currentTheme: 'light',
    };
  },
  async mounted() {
    this.currentTheme = initTheme();
    try { await NotificationService.init(); } catch (e) { console.warn(e); }
  },
  methods: {
    toggleTheme() {
      this.currentTheme = toggleThemeHelper();
    },
  },
};
</script>

<style src="@/assets/theme.css"></style>

<style lang="scss">
#app,
body {
  background: var(--bg-gradient) !important;
  color: var(--text-primary);
  font-family: var(--font-family);
}

.main-header {
  margin-top: 10px !important;
  color: var(--accent-primary);
  font-weight: bold;
  font-size: clamp(1.2rem, 1.5vw, 2.2rem);
}

h5 {
  font-size: 18px !important;
  font-weight: bold;
  color: var(--text-secondary);
}

h6 {
  color: var(--accent-primary);
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 0.5rem !important;
  color: var(--text-secondary);
}

.form-group {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.icon {
  font-size: 2rem;
  color: var(--accent-primary) !important;
}

.icon1 {
  font-size: 1.6rem;
  color: var(--accent-primary);
}

.color {
  color: var(--text-secondary) !important;
}

.line {
  display: block;
  max-width: 98%;
  height: 2px;
  background-color: var(--grid-lines);
  margin: 10px 0;
}

.card-body {
  margin-bottom: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
  margin-right: 10px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--grid-lines);
  transition: 0.4s;
  border-radius: var(--radius-input);
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: var(--accent-primary);
}

input:checked + .slider:before {
  transform: translateX(14px);
}

.general-btn {
  background-color: var(--accent-primary);
  border: none;
  border-radius: var(--radius-button);
  color: #fff;
  padding: 5px 15px !important;
  cursor: pointer;
  font-size: 16px;
  max-height: 35px;
  text-wrap: nowrap;
  transition: var(--transition);
}
.general-btn:hover { background-color: var(--accent-primary-hover); }

.general-btn-secondary {
  background-color: var(--card-bg);
  color: var(--text-primary);
  border: 1px solid var(--grid-lines);
  border-radius: var(--radius-button);
  padding: 5px 15px !important;
  cursor: pointer;
  font-size: 16px;
  max-height: 35px;
  text-wrap: nowrap;
  transition: var(--transition);
}
.general-btn-secondary:hover { background-color: var(--card-bg); box-shadow: var(--shadow); }

.general-btn-excel {
  background-color: var(--success);
  border: none;
  border-radius: var(--radius-button);
  color: #fff;
  padding: 5px 15px;
  cursor: pointer;
  font-size: 16px;
  max-height: 35px;
  text-wrap: nowrap;
  transition: var(--transition);
}
.general-btn-excel:hover { filter: brightness(0.95); box-shadow: var(--shadow); }

/* Button size variants (tokenized) */
.general-btn--sm,
.btn--sm {
  padding: 4px 10px !important;
  font-size: 14px !important;
  line-height: 1.2;
  min-height: 28px;
}

.showMore {
  color: var(--success);
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  margin-top: 10px;
  border-radius: var(--radius-card);
}

@media only screen and (max-width: 499px) {
  .truncated-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 103px; /* Adjust as needed */
    display: inline-block;
  }
}

.nav-link {
  color: var(--accent-primary) !important;
  font-weight: 600;
}

.timeline {
  z-index: 999 !important;
}

.online-status {
  background-color: var(--accent-primary);
  border: none;
  border-radius: var(--radius-button);
  color: #fff;
  padding: 10px 20px;
  margin-left: 20px;
  cursor: pointer;
  font-size: 16px;
}

.online-status:hover {
  background-color: var(--accent-primary-hover);
  color: #fff;
}

.timeline {
  position: sticky;
  top: 0;
  background-color: var(--card-bg);
  padding: 10px;
  border-bottom: 1px solid var(--grid-lines);
  width: 100vw;
  margin-bottom: 2rem;
  z-index: 1;
}

.chart-title {
  font-size: 20px;
  color: var(--accent-primary) !important;
  font-weight: bold;
}

.chart-title-m {
  font-size: 20px;
  color: var(--accent-primary) !important;
  font-weight: bold;
}

/* bashboards*/
.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--grid-lines);
  padding-bottom: 5px;
  margin-bottom: 0.5rem;
}

@media only screen and (max-width: 749px) {
  .chart-header {
    display: flex;
    gap: 20px !important;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--grid-lines);
    padding-bottom: 5px;
    margin-bottom: 0.5rem;
  }
}

.dash-info-item-table {
  padding: 10px;
  margin: 15px;
  background-color: var(--card-bg);
  border-radius: var(--radius-card);
  max-height: 500px;
  min-height: 495px;
}

.dash-info-item-table1 {
  //not general
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: unset;
  margin: 10px;
  border-radius: var(--radius-card);
}

.dash-info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 5px;
  margin: 10px;
  border-radius: var(--radius-card);
  margin: 10px;
}

.dash-cards {
  overflow: hidden;
  padding: 10px;
  border-radius: var(--radius-card);
  background-color: var(--card-bg);
  margin: 10px;
}

.dash-info-gen {
  display: grid;
  grid-template-columns: 1fr;
  border-radius: var(--radius-card);
  background-color: var(--card-bg) !important;
  gap: 5px;
  margin: 15px;
}

.dash-info > div {
  min-height: 300px;
  margin: 10px;
  border-radius: var(--radius-card);
  padding: 10px;
}

.dash-info-gen > div {
  min-height: fit-content;
  border-radius: var(--radius-card);
  padding: 10px;
}

////////////////////////////////////////////////////////////////////////////////////////////////
.tag {
  font-size: 13px;
  cursor: pointer;
}

//------------------------stats container----------------------------------------

.stats-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: fit-content;
  gap: 10px;
  border: 1.5px solid var(--grid-lines);
  border-radius: var(--radius-card);
  padding: 5px;
  margin: 5px 0;
  min-height: 80px !important;
  max-height: fit-content;
}

.stats-container div {
  padding: 2px 10px;
  width: fit-content !important;
}

.stats-container .line {
  height: 50px;
  width: 3px;
  background-color: var(--grid-lines);
}

.stats-container h5 {
  color: var(--accent-primary);
  font-weight: 600;
}

.stats-container h6 {
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 14px;
}

//----------------------------------------------------------------
.queries-container {
  display: flex;
  margin: 10px 0;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
}

.queries {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
}

.query-selector {
  min-width: 25%;
}

.query {
  min-width: 25%;
  padding: 5px;
  border-radius: var(--radius-input);
}

.search-popup {
  display: none;
}

.mobile-search {
  display: none;
}

//----------------------------------------------------------------*/
@import "assets/css/styles.scss";

.main-finance-reports1 {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.finance-scrollspy {
  position: sticky;
  top: 10px;
}

.report-description {
  /* height: 100vh;*/
  overflow-y: auto;
  margin: 0.2rem;
}

.report-container {
  border-radius: var(--radius-card);
  background-color: var(--card-bg);
  box-shadow: var(--shadow);
  padding: 10px;
  margin-top: 0.5rem;
  margin-bottom: 0.6rem;
}

.fin-navigation {
  background-color: var(--card-bg);
  padding: 10px;
  margin-left: 1rem;
  border-radius: var(--radius-card);
  margin-top: 0.6rem;
  min-width: 180px;
}

.report-type {
  border-radius: var(--radius-card);
  border: 1px solid var(--grid-lines) !important;
  padding: 10px;
  margin-top: 0.6rem;
  margin-bottom: 10px;
  cursor: pointer;
}

.report-disc {
  color: var(--accent-primary);
  font-size: 16px !important;
  font-weight: bold;
  padding-top: 10px;
}

.stat-header {
  font-size: 1rem !important;
  margin-top: 10px;
  font-weight: bold;
  color: var(--accent-primary) !important;
}

/*--media querys  -->*/

@media (max-width: 850px) {
  .chart {
    height: fit-content;
    overflow-y: auto;
  }
}

@media (min-width: 340px) {
  p {
    font-size: 0.95rem !important;
  }
}

@media (min-width: 992px) {
  .col-lg-5 {
    padding: 0 !important;
  }
  .col-lg-4 {
    padding: 0 !important;
  }
  .col-lg-3 {
    padding: 0 !important;
  }
}

@media (max-width: 390px) {
  .chart-header {
    justify-content: center;
    align-items: center;
    gap: 2rem;
    margin: 0.6rem 1rem;
  }
}

@media (max-width: 1200px) {
  .dash-info {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .dash-cards {
    margin: 0;
  }
}

@media only screen and (max-width: 749px) {
  .desktop {
    display: none !important;
  }

  .mobile {
    display: block !important;
    margin-bottom: 2rem;
  }
}

@media (max-width: 850px) {
  .stats-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-items: center;
  }

  .stats-container .line {
    display: none;
  }
}

@media (min-width: 750px) {
  .rev-items p,
  .pos-items p {
    font-size: 26px !important;
    margin-bottom: 19px !important;
  }
}

@media only screen and (max-width: 749px) {
  .icon {
    font-size: 20px;
  }
  .mobile-searchbar {
    display: block;
    z-index: 999;
    position: static;
  }

  .mobile-search {
    display: flex;
    justify-content: end;
    background-color: var(--card-bg);
    border-radius: var(--radius-card);
    margin-right: 5px;
    align-items: center;
    text-align: center;
    padding: 10px;
  }
  .mobile-search1 {
    display: flex !important;
    justify-content: end;
    background-color: var(--card-bg);
    border-radius: var(--radius-card);
    margin-right: 5px;
    align-items: center;
    text-align: center;
    padding: 10px;
  }
}

@media only screen and (max-width: 517px) {
  .queries-container {
    display: none;
  }
  .search-popup {
    margin-right: 20px;
    display: flex !important;
    justify-content: end;
  }
  .query {
    width: 100%;
  }
}

@media only screen and (max-width: 400px) {
  .main-finance-reports {
    margin-top: 1rem;
    margin-bottom: 2rem;
    overflow-y: auto;
  }
}
  /* L⚡t‑ning design overrides (tokens-based, no logic changes) */
  .icon, .icon1 { color: var(--accent-primary) !important; }
  h5, p, .color { color: var(--text-secondary) !important; }
  h6 { color: var(--accent-primary) !important; }
  .nav-link { color: var(--accent-primary) !important; }
  .chart-title, .chart-title-m { color: var(--accent-primary) !important; }
  .line { background-color: var(--grid-lines) !important; }

  .online-status { background-color: var(--accent-primary) !important; color: #fff !important; border-radius: var(--radius-button) !important; }
  .online-status:hover { background-color: var(--accent-primary-hover) !important; }

  .timeline { background-color: var(--card-bg) !important; border-bottom: 1px solid var(--grid-lines) !important; }

  .dash-cards,
  .dash-info-item-table,
  .dash-info-item-table1,
  .dash-info-gen,
  .dash-info > div { background-color: var(--card-bg) !important; border-radius: var(--radius-card) !important; }

  .chart-header { border-bottom: 1px solid var(--grid-lines) !important; }

  /* Mobile search surfaces */
  .mobile-search, .mobile-search1 { background-color: var(--card-bg) !important; border-radius: var(--radius-card) !important; }

  /* Ensure tokens are defined even if theme file fails */
  :root {
    --font-family: 'Montserrat', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
    --text-primary: #0F172A;
    --text-secondary: #64748B;
    --accent-primary: #339CFF;
    --accent-primary-hover: #2370CC;
    --accent-secondary: #A529FF;
    --success: #32D74B;
    --danger: #FF3B30;
    --warning: #FF9500;
    --bg: #FFFFFF;
    --bg-gradient: linear-gradient(to bottom, #FFFFFF, #F0F4F8);
    --card-bg: #F8FAFC;
    --card-border-color: #E2E8F0;
    --card-border: 1px solid var(--card-border-color);
    --shadow: 0 2px 8px rgba(0,0,0,0.08);
    --grid-lines: #E2E8F0;
    --tab-inactive: #94A3B8;
    --transition: 0.3s ease all;
    --focus-ring: 2px solid var(--accent-secondary);
    --radius-button: 5px;
    --radius-card: 5px;
    --radius-input: 5px;
  }

  /* PWA Install button (scoped in component; override globally with !important) */
  .install-button { background-color: var(--accent-primary) !important; color: #fff !important; border-radius: var(--radius-button) !important; }
  .install-button:hover { background-color: var(--accent-primary-hover) !important; }

  /* Floating scroll-to-top */
  .floating-container .floating-button { background: var(--accent-primary) !important; border-radius: var(--radius-button) !important; }

  /* Timeline selection controls */
  .timeline-btn { background-color: var(--accent-primary) !important; border-radius: var(--radius-button) !important; border: none !important; color: #fff !important; }
  .timeline-btn.active { background-color: var(--accent-primary-hover) !important; }

  /* Generic radius cap enforcement */
  [style*="border-radius: 6px"],
  [style*="border-radius: 7px"],
  [style*="border-radius: 8px"],
  [style*="border-radius: 9px"],
  [style*="border-radius: 10px"],
  [style*="border-radius: 12px"],
  [style*="border-radius: 15px"],
  [style*="border-radius: 20px"],
  [style*="border-radius: 50px"],
  [style*="border-radius: 100px"],
  [style*="border-radius: 100%"],
  .card,
  [class*="dash-"],
  .btn,
  input,
  select,
  textarea { border-radius: var(--radius-card) !important; }

  /* Map legacy brand blues and grays to tokens */
  [style*="#004080"],
  .text-blue,
  .report-disc,
  .stat-header { color: var(--accent-primary) !important; }

  [style*="#6e6e6e"],
  [style*="#606266"],
  .muted,
  .text-muted { color: var(--text-secondary) !important; }

  /* Borders and surfaces */
  [style*="#939393"],
  .border-gray { border-color: var(--grid-lines) !important; }
  [style*="background-color: #ffffff"],
  .bg-white-card { background-color: var(--card-bg) !important; }

</style>

